import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import telemetry from "./services/telemetry";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

// Aplica el tema (claro/oscuro) antes de montar para evitar parpadeo
if (localStorage.getItem("theme") === "dark") {
  document.documentElement.classList.add("dark");
}

const app = createApp(App);

app.use(router);
app.mount("#app");

telemetry.init();
if (localStorage.getItem("token")) {
  telemetry.identifySesion().then(telemetry.enviaPendientes);
} else {
  telemetry.enviaPendientes();
}
